import { useQueryParamState } from '@mainstage/core-components';
import { useCallback, useMemo } from 'react';

export function useStorageParams<T>(
  key: string,
  defaultValues: T,
): [T, (newParams: T) => void] {
  const [params, setParams] = useQueryParamState<T>('filters');

  const storageParams: T = useMemo(() => {
    if (params) {
      return params;
    }

    try {
      const storageFilters = sessionStorage.getItem(key);
      return storageFilters ? JSON.parse(storageFilters) : defaultValues;
    } catch {
      return defaultValues;
    }
  }, [defaultValues, key, params]);

  const setStorageParams = useCallback(
    (newParams: T) => {
      try {
        sessionStorage.setItem(key, JSON.stringify(newParams));
        setParams(newParams);
      } catch (e) {
        throw new Error(
          `Failed to set the query params inside the session storage. ${e}`,
        );
      }
    },
    [key, setParams],
  );

  return [storageParams, setStorageParams];
}
